<div fxLayout="column"
     fxLayoutAlign="start stretch"
     class="p-32 w-100">
    <div class="h3-semi-bold c-primary-gray-900 text-center pre-line">
        {{ 'i18n_af_changePasswordTitle' | translate }}
    </div>

    @if (form) {
        <form [formGroup]="form"
              (submit)="submit()"
              fxLayout="column"
              fxLayoutAlign="start stretch"
              class="mt-24">
            @if (form.controls.currentPassword) {
                <div
                    fxLayout="column"
                    fxLayoutAlign="start start"
                    class="w-100">
                    <div class="t5 c-primary-gray-600">
                        {{ 'i18n_af_labelOldPassword' | translate }}*
                    </div>
                    <mat-form-field class="w-100 mt-4"
                                    [class.value-not-empty]="form.value.currentPassword">
                        <input matInput
                               [type]="showCurrentPassword ? 'text' : 'password'"
                               formControlName="currentPassword"
                               [placeholder]="'i18n_af_placeholderOldPassword' | translate"
                               name="currentPassword"/>
                        <ui-kit-svg matRipple
                                    matSuffix
                                    class="i-24 circle pointer p-8 c-primary-green-900"
                                    [name]="showCurrentPassword ? 'ic_eye_show' : 'ic_eye_hide'"
                                    (click)="showCurrentPassword =! showCurrentPassword">
                        </ui-kit-svg>
                        @if (form.controls.currentPassword.hasError('required')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                            </mat-error>
                        }
                        @if (form.controls.currentPassword.hasError('invalidCurrent')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_errorCurrentPasswordInvalid' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
            }
            <div fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-24">
                <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelNewPassword' | translate }}*</div>
                <mat-form-field class="w-100 mt-4"
                                [class.value-not-empty]="form.value.newPassword">
                    <input matInput
                           [type]="showNewPassword ? 'text' : 'password'"
                           formControlName="newPassword"
                           [maxlength]="maxLength"
                           [placeholder]="'i18n_af_placeholderNewPassword' | translate"
                           name="newPassword"/>
                    <ui-kit-svg matRipple
                                matSuffix
                                class="i-24 circle pointer p-8 c-primary-green-900"
                                [name]="showNewPassword ? 'ic_eye_show' : 'ic_eye_hide'"
                                (click)="showNewPassword =! showNewPassword">
                    </ui-kit-svg>
                    @if (form.controls.newPassword.hasError('passwordHistory')) {
                        <mat-error class="c-secondary-red-900">
                            {{ 'i18n_af_errorPasswordHistory' | translate }}
                        </mat-error>
                    }
                </mat-form-field>
                <af-password-requirements class="w-100 mt-4" [password]="form.value.newPassword"/>
            </div>
            @if (form.controls.confirmPassword) {
                <div
                    fxLayout="column"
                    fxLayoutAlign="start start"
                    class="w-100 mt-24">
                    <div class="t5 c-primary-gray-600">
                        {{ 'i18n_af_labelConfirmPassword' | translate }}*
                    </div>
                    <mat-form-field class="w-100 mt-4"
                                    [class.value-not-empty]="form.value.confirmPassword">
                        <input matInput
                               [type]="showConfirmPassword ? 'text' : 'password'"
                               formControlName="confirmPassword"
                               [maxlength]="maxLength"
                               [placeholder]="'i18n_af_placeholderConfirmPassword' | translate"
                               name="confirmPassword"/>
                        <ui-kit-svg matRipple
                                    matSuffix
                                    class="i-24 circle pointer p-8 c-primary-green-900"
                                    [name]="showConfirmPassword ? 'ic_eye_show' : 'ic_eye_hide'"
                                    (click)="showConfirmPassword =! showConfirmPassword">
                        </ui-kit-svg>
                        @if (form.controls.confirmPassword.hasError('required')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                    @if (form.errors?.mismatch && form.controls.confirmPassword.value && form.controls.confirmPassword.touched) {
                        <div class="t5 c-secondary-red-800">{{ 'i18n_af_errorPasswordMismatch' | translate }}</div>
                    }
                </div>
            }
            <div fxLayout="column" fxLayoutAlign="center center" class="mt-32">
                <ui-kit-button
                    spinnerId="change-password"
                    [disabled]="form.invalid"
                    [label]="'i18n_af_buttonSave' | translate"/>
                <ui-kit-button
                    class="mt-16"
                    type="text"
                    buttonType="button"
                    color="accent"
                    (clickListener)="close()"
                    [label]="'i18n_af_buttonCancel' | translate"/>
            </div>
        </form>
    }
</div>
